import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import { BaseUrl } from "../../helper/BaseUrl";

const getEndpoint = ApiEndpoints.home.list;
const updateEndpoint = ApiEndpoints.home.update;
const addEndpoint = ApiEndpoints.home.create;

export default function Home() {

  const navigate = useNavigate();

  const [previews, setPreviews] = useState({ image_section3: null, slider: [null] });
  const [postData, setPostData] = useState({ slider: [{ title: "", brief: "", image: null, alt_image: "" }], quote: "", title_section3: "", description_section3: "", image_section3: null, alt_image_section3: "", cta_link_section3: "" });

  const fetchData = async () => {
    try {
      const response = await ApiRequest("GET", getEndpoint);
      const data = response?.homes?.[0] || {};
      setPostData(data)

      setPreviews((prev) => ({
        ...prev,
        image_section3: data ? BaseUrl + data?.image_section3 : prev?.image_section3,
        slider: data?.slider?.map(img =>
          img.image ? BaseUrl + img.image : null
        ) || []
      }))
    } catch (error) {
      console.error("Failed to fetch categories:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleImageChange = (index, file) => {
    const updatedImages = [...postData.slider];
    updatedImages[index].image = file;

    setPostData(prev => ({
      ...prev,
      slider: updatedImages
    }));

    const updatedPreviews = [...previews.slider];
    updatedPreviews[index] = URL.createObjectURL(file);

    setPreviews(prev => ({
      ...prev,
      slider: updatedPreviews
    }));
  };

  const handleSliderChange = (index, key, value) => {
    const updatedSlider = [...postData.slider];
    updatedSlider[index][key] = value;

    setPostData(prev => ({
      ...prev,
      slider: updatedSlider
    }));
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];
      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      // For non-file inputs, update the postData state directly
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };

  // ================Validations And Submit Handler====================

  const isEmptyValue = (value) => {
    if (value === null || value === "") return true;

    // allow File objects
    if (value instanceof File) return false;

    // arrays
    if (Array.isArray(value)) {
      return value.some(item => isEmptyValue(item));
    }

    // objects
    if (typeof value === "object") {
      return Object.values(value).some(v => isEmptyValue(v));
    }

    return false;
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if (key === "location") continue;

      if (isEmptyValue(value)) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

    const imagesPayload = postData.slider.map((item, index) => ({
      image: item.image ? item.image.name || item.image : "",
      alt_image: item.alt_image,
      brief: item.brief,
      title: item.title,
    }));

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      if (key !== "slider") {
        formData.append(key, value);
      }
      if (key === "slider") {
        formData.append(key, JSON.stringify(imagesPayload))
      }
    });

    postData.slider?.forEach((item, index) => {
      if (item.image) {
        if (item.image instanceof File) {
          formData.append(`slider[${index}][image]`, item.image);
        }
      }
    });

    const finalEndpoint = postData?._id ? updateEndpoint + postData?._id : addEndpoint;
    try {
      const response = await ApiRequest("POST", finalEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.error === false) {
        toast.success(response.message);
        fetchData();
        navigate("/home");
      } else {
        toast.error(response.message)
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  // =================Add More Functionality Start=====================

  const addImageBlock = () => {
    setPostData(prev => ({
      ...prev,
      slider: [...prev.slider, { image: null, alt_image: "", title: "", brief: "" }]
    }));

    setPreviews(prev => ({
      ...prev,
      slider: [...prev.slider, null]
    }));
  };

  const removeImageBlock = (index) => {
    if (index === 0) return;

    setPostData(prev => ({
      ...prev,
      slider: prev.slider.filter((_, i) => i !== index)
    }));

    setPreviews(prev => ({
      ...prev,
      slider: prev.slider.filter((_, i) => i !== index)
    }));
  };

  // =================Add More Functionality End=====================

  const pagename = {
    name: 'Home Management',
    user: 'Admin',
    innerpage: 'Home Management / Home Page'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form id="projectAdd" onSubmit={handleSubmit}>

          <div className="add-content-wrap">
            <h4>Slider Section</h4>

            <div className="row">
              {postData?.slider?.map((item, index) => (
                <div className="col-lg-12" key={index}>
                  <div className="add-content-wrap">
                    <div className="row">

                      <div className="col-lg-12">
                        <div className="add-page-inputs">
                          <div className="label-wrap-add">
                            <label>Slider {index + 1} Title <small>*</small></label>
                          </div>

                          <input type="text" className="form-control mt-2" placeholder="Alt image" value={item.title} onChange={(e) => handleSliderChange(index, "title", e.target.value)} />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="add-page-inputs">
                          <div className="label-wrap-add">
                            <label>Slider {index + 1} Image (1680 X 893 px)<small>*</small></label>
                          </div>
                          <CustomImageUpload name={`image_${index}`} acceptedFormats={[".webp"]} imagePreview={previews.slider[index]} onImageChange={(e) => handleImageChange(index, e.target.files[0])} />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="add-page-inputs">
                          <div className="label-wrap-add">
                            <label>Slider {index + 1} Image Alt<small>*</small></label>
                          </div>

                          <input type="text" className="form-control mt-2" placeholder="Alt image" value={item.alt_image} onChange={(e) => handleSliderChange(index, "alt_image", e.target.value)} />
                        </div>

                        <div className="add-page-inputs mt-5">
                          <div className="label-wrap-add">
                            <label>Slider {index + 1} Description<small>*</small></label>
                          </div>

                          <input type="text" className="form-control mt-2" placeholder="Alt image" value={item.brief} onChange={(e) => handleSliderChange(index, "brief", e.target.value)} />
                        </div>
                      </div>
                    </div>

                    {index > 1 && (
                      <button type="button" className="btn btn-danger mt-2" onClick={() => removeImageBlock(index)}>
                        Remove
                      </button>
                    )}
                  </div>
                </div>
              ))}

              <div className="col-lg-12 text-center mt-3">
                <button type="button" className="btn btn-success" onClick={addImageBlock}>
                  Add More Slides
                </button>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>quote<small>*</small></label>
                  </div>
                  <input value={postData.quote} onChange={handleChange} name="quote" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Section 3 Title<small>*</small></label>
                  </div>
                  <input value={postData.title_section3} onChange={handleChange} name="title_section3" type="text" className="form-control" placeholder="alt thumbnail" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Section 3 CTA Link<small>*</small></label>
                  </div>
                  <input value={postData?.cta_link_section3} onChange={handleChange} name="cta_link_section3" type="text" className="form-control" placeholder="Enter city" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Section 3 Image Alt Tag<small>*</small></label>
                  </div>
                  <input value={postData.alt_image_section3} onChange={handleChange} name="alt_image_section3" type="text" className="form-control" placeholder="alt thumbnail" />
                </div>

                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Section 3 Image (750 × 750)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="image_section3"
                    // maxSize={550 * 1024}
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.image_section3} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Section 3 Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.description_section3} onChange={(event) => handleEditorChange("description_section3", event?.editor?.getData())} />
                </div>
              </div>

            </div>
          </div>

        </form>
        <button type="submit" form="projectAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  )
}
